module.exports = __webpack_public_path__ + "static/img/first-bet-characte-01.d1fad47.png";